import React from "react";
import { Modal } from "@gw/web-basic-components";
import classNames from "classnames";
import { GWTransfer } from "../../..";
import type { IRelationModalProps } from "./dto";
import styles from "./index.module.less";
/**
 * 关联弹窗
 */
const RelationModal = (props: IRelationModalProps) => {
  return (
    <Modal
      destroyOnClose
      style={props.style}
      className={classNames(styles.relationForm, props.className)}
      title={props.title || "关联"}
      visible={props.isModalVisible}
      centered={true}
      maskClosable={false}
      onCancel={props.onOk}
    >
      <GWTransfer {...props.transferConfig} visible={props.isModalVisible} />
    </Modal>
  );
};
export default RelationModal;
